export default __webpack_public_path__ + "static/media/AGC_2025_R1_QP_Class_3.efe46600.pdf";